import React from 'react';
import './About.css'


const About = () => {
    return (
        <div class=" aboutBackground">
            <h3 className="py-4">About Me</h3>
            <div class="row" style={{ margin: 0, height: "100%" }} >
                <div class="col-12" >
                    <h4> MY NAME IS AKTARUZZAMAN RIDOY</h4>
                </div>
            </div>

        </div>
    );
};

export default About;